import {
     SHOW_ADDINTERVIEW_MODAL ,
     HIDE_ADDINTERVIEW_MODAL ,
     START_ADDINTERVIEW_MODAL,
     DONE_ADDINTERVIEW_MODAL,
     ADD_INTERVIEW_DATA ,
}
    from 'constants/addInterview';
    const initialState = {
        showModel:false,
        isLoading:false,
        AddInterviewList:[],
    };
    export default function addInterviews(state = initialState,actions){
        switch(actions.type){
            case START_ADDINTERVIEW_MODAL:
                return {...state,isLoading:true};
            case DONE_ADDINTERVIEW_MODAL:
                return {...state,isLoading:false};
            case ADD_INTERVIEW_DATA:
                return {...state,AddInterviewList:actions.addInterviewList};
            case HIDE_ADDINTERVIEW_MODAL:
                return {...state,showModel:false};
            case SHOW_ADDINTERVIEW_MODAL:
                return {...state,showModel:true};
            default:
                return state;
        }
    } 


// WEBPACK FOOTER //
// ./src/reducer/addInterview.js